// -*- Mode: rjsx -*-
import React, { useState } from 'react';

import Button from '@mui/material/Button';
import Popover from '@mui/material/Popover';
import Slide from '@mui/material/Slide';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';

import SettingsIcon from '@mui/icons-material/Settings';
import SignOutIcon from '@mui/icons-material/ExitToApp';

import { Link } from "react-router-dom";

import { FHMaterialStyles } from "../../../ui/fh-material-styles.js";
import { AvatarImage } from '../../../ui/Avatar.js';

import { useSelector } from 'react-redux';

function Item(props) {
    return (
        <Link to={props.url} style={{ color: "black" }}>
          <ListItem button>
            <ListItemIcon>
              { props.icon }
            </ListItemIcon>
            <ListItemText primary={props.text} />
          </ListItem>
        </Link>
    );
}

function Menu(props) {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const classes = FHMaterialStyles();

    const me = useSelector(state => state.hud.user);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    
    const handleClose = () => {
        setAnchorEl(null);
    };

    const goto = (url) => {
        window.location.href = url;
    };
    
    return (
        <>

          <Button onClick={handleClick}>
            <AvatarImage style={{ maxHeight: 32 }} user={me} />            
          </Button>

		  <Popover
            id="fade-menu"
            getContentAnchorEl={null}
            anchorEl={anchorEl}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'center'}}
            keepMounted
            open={open}
            onClose={handleClose} 
            TransitionComponent={Slide}
		  >
            <List component="nav" aria-label="Main User Options">
              
              <Item text="Settings" icon={<SettingsIcon />} url="/queue/settings" />
              <Item text="Sign Out" icon={<SignOutIcon />} url="/signout" />
              
            </List>
          </Popover>
        
        </>
	);
};

export { Menu };
